import { Box, Chip, Tooltip } from '@mui/material';
import React from 'react';
import {
  overflowChipTagsContainerSx,
  overflowChipTagsSummaryWrapperSx,
} from './styles';
import { OverflowChipTagsProps } from './types';

export function OverflowChipTags<T>({
  selectedValues,
  getTagProps,
  getOptionKey,
  getOptionLabel,
  maxVisibleTags,
  size,
}: OverflowChipTagsProps<T>): React.ReactElement {
  const visibleValues = selectedValues.slice(0, maxVisibleTags);
  const hiddenValues = selectedValues.slice(maxVisibleTags);
  const hiddenValuesLabel = hiddenValues
    .map((option) => getOptionLabel(option))
    .join(', ');

  return (
    <Box sx={overflowChipTagsContainerSx}>
      {visibleValues.map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={String(getOptionKey(option))}
          label={getOptionLabel(option)}
          size={size ?? 'medium'}
        />
      ))}
      {hiddenValues.length > 0 && (
        <Box sx={overflowChipTagsSummaryWrapperSx}>
          <Tooltip title={hiddenValuesLabel}>
            <Chip label={`+${hiddenValues.length}`} size={size ?? 'medium'} />
          </Tooltip>
        </Box>
      )}
    </Box>
  );
}